import Colors from '@/constants/colors';
import { Layout } from '@/constants/layout';

interface PageContainerProps {
  children: React.ReactNode;
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchMove?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: React.TouchEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

export default function PageContainer({ children, onTouchStart, onTouchMove, onTouchEnd, style }: PageContainerProps) {
  return (
    <div
      style={{ ...styles.container, ...style }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {children}
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: Colors.background,
    minHeight: '100%',
    paddingBottom: Layout.navHeight,
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
  } as React.CSSProperties,
};
